module.exports = __webpack_public_path__ + "img/ywbk09.38e51056.jpg";